// Gatsby requirements
import React, { useState } from "react"
import { storyblokEditable } from "gatsby-source-storyblok";

// Components
import RichTextRenderer from 'utils/richTextRenderer'

// Styles
import * as CSS from './sectionReviewForm.module.scss'
import './sectionReviewForm.scss'

const SectionContactForm = ({ blok, currentPage, en }) => {

    // Form logic
    const [state, setState] = React.useState({})
    const [formSubmitted, setFormSubmitted] = useState(false)
    const handleChange = (e) => {
      setState({ ...state, [e.target.name]: e.target.value })
    }
    function encode(data) {
        return Object.keys(data)
          .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
          .join('&')
    }
    const handleSubmit = (e) => {
      e.preventDefault()
      const form = e.target
      fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: encode({
          'form-name': form.getAttribute('name'),
          ...state,
        }),
      })
        .then(() => setFormSubmitted(true))
        .catch((error) => alert(error))
    }

    // Logic for star rating
    const [starRating1, setStarRating1] = useState(0)
    const [starRating2, setStarRating2] = useState(0)
    const [starRating3, setStarRating3] = useState(0)
    const [starRating4, setStarRating4] = useState(0)
    const [starRating5, setStarRating5] = useState(0)
    const [starRating6, setStarRating6] = useState(0)


    return (
        <section
            className={CSS.section}
            id={blok.anchorId}
            style={{ backgroundColor: blok.backgroundColor }}
            {...storyblokEditable(blok)}
        >

            <div className="wrapper">

                <div className={CSS.wrapper}>

                    <div style={{maxWidth: blok.limitMaxWidth === true ? '54em' : '100%'}} className={CSS.form}>

                        {blok.richText &&
                            <div className={CSS.richtext}>
                                <RichTextRenderer data={blok.richText} />
                            </div>
                        }

                        <form
                            name={currentPage}
                            method="POST"
                            data-netlify="true"
                            data-netlify-honeypot="bot-field"
                            onSubmit={handleSubmit}
                        >

                            <input type="hidden" name="form-name" value="contact" />
                            <p hidden>
                                <label>
                                    Don’t fill this out: <input name="bot-field" onChange={handleChange} />
                                </label>
                            </p>

                            <div className={CSS.ratingsAndLogo}>
                                <div className={CSS.logo}>
                                    <img src={blok?.logo?.filename + '/m/250x0/filters:quality(90)'} alt={blok?.logo?.alt} loading="lazy" />
                                </div>
                                <div className={CSS.ratings}>
                                    {blok?.ratingCategories?.map((loop, i) => (
                                    <label key={i} className="rating-label">
                                        {loop?.text}
                                        <input
                                            className="rating"
                                            max="5"
                                            min="0"
                                            name={loop?.text}
                                            required
                                            onChange={(event) => { handleChange(event); i === 0 ? setStarRating1(event.target.value) : i === 1 ? setStarRating2(event.target.value) : i === 2 ? setStarRating3(event.target.value) : i === 3 ? setStarRating4(event.target.value) : i === 4 ? setStarRating5(event.target.value) : setStarRating6(event.target.value) }} 
                                            step="0.5"
                                            style={`--value:${i === 0 ? starRating1 : i === 1 ? starRating2 : i === 2 ? starRating3 : i === 3 ? starRating4 : i === 4 ? starRating5 : starRating6}`}
                                            type="range"
                                            value={i === 0 ? starRating1 : i === 1 ? starRating2 : i === 2 ? starRating3 : i === 3 ? starRating4 : i === 4 ? starRating5 : starRating6}
                                        />
                                    </label>
                                    ))}
                                </div>
                            </div>

                            <label for="message">{en === true ? 'Describe your experience with the insurance' : 'Omschrijf je ervaring met verzekering'}</label>
                            <textarea onChange={handleChange} id="message" name="message" required />

                            <div className={CSS.flex}>
                                <div>
                                    <label for="name">{en === true ? 'Name' : 'Naam:'}</label>
                                    <input onChange={handleChange} type="text" id="name" name="name" required />
                                </div>
                               
                                <div>
                                    <label for="email">{en === true ? 'Email (will stay private):' : 'E-mail (blijft privé):'}</label>
                                    <input onChange={handleChange} type="email" id="email" name="email" required />
                                </div>
                            </div>
                            <button className="button" type="submit" name="submit">{en === true ? 'Send' : 'Plaats uw review'}</button>
                        </form>
                        <p id="form-success" style={{display: formSubmitted === true ? 'block' : 'none'}} className={CSS.success}>{en === true ? 'Successfully sent!' : 'Bedankt, het bericht is verzonden.'}</p>
                    </div>

                </div>

            </div>

        </section>
    )
}

export default SectionContactForm